
<template  minapp='mpx' xlang='wxml'>
  <view
    class="swiper-container"
    wx:if="{{ listData && listData.length > 0 }}"
    wx:class="{{paddingClass}}"
  >
    <swiper
      display-multiple-items="1"
      bindchange="onChange"
      indicator-dots="{{false}}"
      indicator-color="#FFFFFF"
      current="{{initIndex}}"
      autoplay="{{false}}"
      circular="{{false}}"
      class="swiper"
      wx:class="{{swpierPadding}}"
      next-margin="10px"
    >
      <view wx:for="{{listData}}" wx:for-item="item" wx:key="index">
        <swiper-item class="swiper-item">
          <view class="{{initIndex === index ? 'train-info-content selected' : 'train-info-content unselected' }}" >
          <refund-info-card class="{{initIndex === index ? '' : 'unselected-item' }}" refundInfo="{{item}}"
          showReason="{{showReason}}"
          />
          </view>
        </swiper-item>
      </view>
    </swiper>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      initIndex: {
        type: Number,
        value: 0
      },
      listData: {
        type: Array,
        value: []
      },
      hasTag: {
        type: Boolean,
        value: false
      },
      showReason: {
        type: Boolean,
        value: true
      }
    },
    data() {
      return {
        current: 0
      }
    },
    watch: {},
    computed: {
      paddingClass() {
        if (__mpx_mode__ === 'dd') {
          return {
            'swiper-didi-padding': true
          }
        } else {
          return {
            'swiper-web-padding': true
          }
        }
      },
      swpierPadding() {
        if (__mpx_mode__ === 'dd') {
          return this.showReason
            ? {
                'swiper-inline-didi-padding-reason': true
              }
            : { 'swiper-inline-didi-padding': true }
        } else {
          return {
            'swiper-inline-web-padding': true
          }
        }
      }
    },
    methods: {
      onChange(event) {
        this.current = event.detail.current
        this.$trigger('change', event.detail.current)
      }
    },
    beforeCreate() {},

    created() {},

    mounted() {},

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .swiper-container
    overflow visible
    background-color $train-color-theme-blue
  .swiper
    width 100%
    // height 113px
    // background-color #FFFFFF
    overflow visible
  .swiper-inline-didi-padding
    margin-top -18px
    padding 0px 0px 0px 0px
    margin-bottom -12px
  .swiper-inline-didi-padding-reason
    margin-top -10px
    padding 0px 0px 0px 0px
    margin-bottom -4px
  .swiper-inline-web-padding
    padding 15px 0px
  .swiper-didi-padding
    padding 0px 0px
  .swiper-web-padding
    padding 0px 15px
  .swiper-item
    // height 105px
    display flex
    justify-content center
    align-items center
  .train-info-content
    display flex
    flex-direction column
    width 97%
    background-color #ffffff
    border-radius 8px
    box-sizing border-box
    &.selected
      // min-height 103px
    &.unselected
      // height 73px
      transform scale(1, 0.75)
  .unselected-item
    transform scale(0.75, 1)
  .train-info-item
    padding 13px 15px 16px 15px
  .train-info-item-top
    padding 3px 15px 16px 15px
  .tag
    background-color #e7f1ff
    width 60px
    height 14px
    color $train-color-theme-blue
    border-radius 8px 1px 8px 1px
  .tag-text
    position relative
    margin-top -2px
    font-size 12px
    -webkit-transform scale(0.84)
    -webkit-transform-origin center
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'refund-info-card': './refund-info-card'
    }
  }
</script>
